import { AuthApi, FlowValidation, FlowsApi, NodeType } from "typescript-axios";
import axios, { getAxiosParams } from "src/lib/axios.config";
const FLOWS_API = new FlowsApi(getAxiosParams(), undefined, axios);
const AUTH_API = new AuthApi(getAxiosParams(), undefined, axios);

export const startFlow = async (flowId: string) => {
  return FLOWS_API.startFlowApiV1FlowsFlowIdStartPost(flowId).then(
    (response) => {
      return response.data;
    }
  );
};

export const stopFlow = async (flowId: string) => {
  return FLOWS_API.stopFlowApiV1FlowsFlowIdStopDelete(flowId).then(
    (response) => {
      return response.data;
    }
  );
};

export const getIssues = async (flowId: string): Promise<FlowValidation> => {
  return FLOWS_API.validateFlowApiV1FlowsFlowIdValidatePost(flowId).then(
    (response) => {
      return response.data;
    }
  );
};

export const readNodeTypes = async (): Promise<NodeType[]> =>
  FLOWS_API.readNodeTypesApiV1FlowsNodesTypesGet("10").then((response) => {
    response.data.forEach((nodeType) => {
      nodeType.init = nodeType.init;
      nodeType.update = nodeType.update;
      nodeType.inputs = nodeType.inputs;
      nodeType.outputs = nodeType.outputs;
    });

    return response.data;
  });

export const getOauthUrl = async (flowId: string): Promise<string | null> => {
  const redirectUrl = window.location.origin + "/auth/scopes";
  localStorage.removeItem("scopes");
  const scopeUrl = await AUTH_API.loginAuthApiV1AuthLoginOauthGet(
    flowId,
    redirectUrl
  ).then((response) => {
    if (response.data?.scopes) {
      localStorage.setItem("scopes", response.data.scopes);
    }
    if (response.data?.url) {
      return response.data.url;
    }
  });
  if (scopeUrl) {
    return scopeUrl;
  }
  return null;
};
